import { CellType } from 'interfaces/cellType';

export const getSupportedCellTypeIds = (cellTypes: CellType[]): Set<string> =>
  new Set(cellTypes.filter(({ cellTypingSupported }) => cellTypingSupported === true).map(({ id }) => id));

export const getCellTypeSupportError = (cellTypeIds: string[], cellTypes: CellType[]): string | null => {
  const supportedIds = getSupportedCellTypeIds(cellTypes);
  const unsupportedIds = cellTypeIds.filter((id) => !supportedIds.has(id));
  if (!unsupportedIds.length) return null;
  const firstId = unsupportedIds[0];
  const firstOption = cellTypes.find(({ id }) => id === firstId);
  const label = firstOption?.displayName || firstId;
  return unsupportedIds.length === 1
    ? firstOption?.cellTypingUnsupportedReason ||
        `Unsupported cell type "${label}". Remove it from Cell rules or choose a supported cell type.`
    : `Unsupported cell types: "${label}" and ${
        unsupportedIds.length - 1
      } others. Remove them from Cell rules or choose supported cell types.`;
};
